import { styled } from '../../../../stitches.config';
import { Button as CoreButton } from '../../../controls/Button/Button';

const Container = styled('div', {
  position: 'absolute',
  right: 0,
  top: 25,
  bottom: 25,
});

const Button = styled(CoreButton, {
  'height': '100%',
  'padding': '$2 !important',
  '& > span': {
    fontSize: '$3 !important',
  },
});

interface ExpandButtonProps {
  onClick: () => void;
}

export function ExpandButton(props: ExpandButtonProps) {
  const { onClick } = props;

  return (
    <Container>
      <Button size="small" theme="purple" icon="start" onClick={onClick} />
    </Container>
  );
}
